import { render, staticRenderFns } from "./DashboardEquipeVendas.vue?vue&type=template&id=2fdff458&scoped=true&"
import script from "./DashboardEquipeVendas.vue?vue&type=script&lang=js&"
export * from "./DashboardEquipeVendas.vue?vue&type=script&lang=js&"
import style0 from "./DashboardEquipeVendas.vue?vue&type=style&index=0&id=2fdff458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdff458",
  null
  
)

export default component.exports